import { Drawer, Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { SelectBox, SVG, Text } from "sunrise-ui";
import {
  getMachineLogs,
  getOverallMachineLogs,
  getSpecificMachineLogs,
} from "../../redux/reducers/machineReducers";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { AppDispatch } from "../../redux/store";
import MachineCard from "./MachineCard";
import MachineLogDrawer from "./MachineLogDrawer";
import Slider from "./Slider";
import List from "./List";
import Loader from "../../utilities/Loader";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";

const displayDate = (dateString: string) => {
  if (dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = `0${date.getDate()}`.slice(-2);
    return `${day} ${month}, ${date.getFullYear()}`;
  }
  return "";
};

const MachineLogs = () => {
  const dispatch = useDispatch<AppDispatch>();

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const overallMachineLogs = useSelector(
    (state: any) => state.MACHINE.overallMachineLogs
  );
  const specificMachineLogs = useSelector(
    (state: any) => state?.MACHINE?.specificMachineLogs
  );
  const machineLogData = useSelector(
    (state: any) => state.MACHINE.machineLogData
  );
  // let masterData = useSelector((state: any) => state.UI.masterData);
  const [dataToDownload, setDataToDownload] = React.useState<any>([]);
  const [projectList, setProjectList] = React.useState([]);
  const [projectName, setProjectName] = React.useState("");
  const [projectId, setProjectId] = React.useState("");
  const [machineData, setMachineData] = React.useState({
    id: "",
    number: "",
    avgDieselConsumption: 0,
    avgRunningHoursPerDay: 0,
    totalWorkingHours: 0,
    ownership: "",
    ownerName: "",
    assignedToProjectOn: "",
    currenStatus: "",
  });
  const [drawerToggle, setDrawerToggle] = React.useState(false);
  const [drawerData, setDrawerData] = React.useState(false);
  const [dieselData, setDieslData] = React.useState({
    dieselFilledBy: { name: "" },
    filledAt: "",
    dieselIssued: 0,
  });
  const changeResetValue = () => {};

  //-------For displaying loader---------
  const [isLoading, setIsLoading] = React.useState(false);

  const fields = [
    {
      header: "Date",
      action: function (obj: any) {
        return (
          <Text
            type="link"
            fonts="normal"
            className="mb0 mt0 capitalize pointer"
            onTextClick={() => {
              fetchLogDetails(obj);
            }}
          >
            {displayDate(obj.date)}
          </Text>
        );
      },
    },
    { header: "Start Reading", value: "startReading", search: true },
    { header: "Close Reading", value: "closeReading", search: true },
    { header: "Diesel Issued", value: "dieselIssued", search: true },
    {
      header: "Operated By",
      value:'operator.name',
      search: true,
      action: function (obj: any) {
        return <span className="capitalize">{obj.operator?.name}</span>;
      },
    },
    {
      header: "Shift",
      value: 'shift',
      search: true,
      action: function (obj: any) {
        return <span className="capitalize">{obj?.shift}</span>;
      },
    },
    { header: "Filled By", value: "dieselFilledBy", search: true },
  ];

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    ).then((res) => setIsLoading(false));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      // getAllAssignedMachineData({
      //   endPoint: `machine/list?status=ASSIGNED&project=${projectId}`,
      // })
      getOverallMachineLogs({
        endPoint: `machine/overall-logs?project=${projectId}`,
      })
    );
    dispatch(
      getSpecificMachineLogs({
        endPoint: `machine/specific-logs?machine=&project=${projectId}`,
      })
    );
    // eslint-disable-next-line
  }, [projectId]);

  useEffect(() => {
    dispatch(
      getSpecificMachineLogs({
        endPoint: `machine/specific-logs?machine=${machineData.id}&project=${projectId}`,
      })
    );
    // eslint-disable-next-line
  }, [machineData]);

  useEffect(() => {
    // eslint-disable-next-line
    // masterData = {};
    // get list of all the projects available
    let arr2: any = [];
    if (allProject !== undefined) {
      let arr: any = [];
      arr = allProject;
      if (arr.length > 0) {
        arr.forEach((val: any) => {
          arr2.push(val.projectName);
        });
        setProjectList(arr2);
      }
    }
  }, [allProject]);

  useEffect(() => {
    setDrawerData(machineLogData);
  }, [machineLogData]);

  const fetchLogDetails = (data: any) => {
    setDieslData(data);

    dispatch(
      getMachineLogs({
        endPoint: `machine/log?id=${data?.id}&date=${data?.date}`,
      })
    ).then((res) => setDrawerToggle(true));
  };

  //get project id method
  const getProjectId = (index: any) => {
    setProjectId(allProject[index]._id);
  };

  // const openDrawer = (data: any) => {
  //   setDrawerData(data);
  //   setDrawerToggle(true);
  // };
  useEffect(() => {
    const nullRemover = (item: any) => {
      return item === null ? "" : item;
    };
    const downloadData: any = specificMachineLogs?.map((val: any) => {
      return {
        Date: nullRemover(val?.date),
        "Start Reading": nullRemover(val?.startReading),
        "Close Reading": nullRemover(val?.closeReading),
        "Diesel Issued": nullRemover(val?.dieselIssued),
        "Operated By": nullRemover(val?.operator?.name),
        "Operator Shift": nullRemover(val?.shift),
        "Filled By": nullRemover(val?.dieselFilledBy?.name),
      };
    });
    setDataToDownload(downloadData);
  }, [specificMachineLogs]);
  return (
    <>
      {isLoading ? (
        <Loader
          color="#5f67e0"
          loading={isLoading}
          size={20}
          height="80vh"
          style={{ width: "inherit" }}
        />
      ) : (
        <Grid container className="mt1">
          <Grid item xs={12} className="mt1 bg--white box--shadow p1">
            <Grid className="standared_width">
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb0 mt0"
              >
                <span className="fw500">Select Project*</span>
              </Text>
              <SelectBox
                data={projectList}
                placeHolder="Select Project"
                defaultVal={projectName}
                resetVal={projectName === "" ? true : false}
                changeReset={changeResetValue}
                onChange={(e) => {
                  let target = { ...e };
                  setProjectName(target.target.value);
                  const index = projectList
                    ?.map((item: any) => item)
                    .indexOf(target.target.value);
                  getProjectId(index);
                }}
                borderColor={"primary"}
              />
            </Grid>
            {projectId && (
              <Grid item xs={12}>
                <Grid container className="pt1">
                  {/* ------Diesel consumption------- */}
                  <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mr-1 mb1">
                    <Grid className="icon_container fuel_icon mr">
                      <SVG type={"fuelCan"} />
                    </Grid>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={18}
                      className="mb0 mt0 fw500 line-height1"
                    >
                      Total Diesel issued for all machines used in project till
                      date:{" "}
                      <span className="fw400">{` ${
                        overallMachineLogs?.totalDieselIssued
                          ? overallMachineLogs.totalDieselIssued
                          : 0
                      } Litres`}</span>
                    </Text>
                  </Grid>
                  {/* ------Average diesel consumption------- */}
                  <Grid className="p1 box--shadow small_info_card d-flex h-center v-center mb1">
                    <Grid className="icon_container fuel_icon_dashed mr">
                      <SVG type={"fuelCanDashed"} />
                    </Grid>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={18}
                      className="mb0 mt0 fw500 line-height1"
                    >
                      Average Diesel consumption per day :{" "}
                      <span className="fw400">{` ${
                        overallMachineLogs?.avgConsumptionPerDay
                          ? overallMachineLogs.avgConsumptionPerDay
                          : 0
                      } Litres`}</span>
                    </Text>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {projectName === "" && (
              <SelectOptionMsg text="Please select the project to get Machine Logs Details." />
            )}
            {overallMachineLogs && (
              <Grid item xs={12}>
                <Grid container className="pt1">
                  {/* ------Machine card------- */}
                  <Slider
                    data={overallMachineLogs?.machines}
                    Component={MachineCard}
                    onSelect={(item: any) => setMachineData(item)}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          {specificMachineLogs && dataToDownload && (
            <List
              listData={specificMachineLogs}
              fields={fields}
              title={"Machines at Site"}
              dataToDownload={dataToDownload}
            />
          )}
          {drawerData && (
            <Drawer
              anchor={"right"}
              open={drawerToggle}
              onClose={() => setDrawerToggle(false)}
            >
              <MachineLogDrawer
                drawerData={drawerData}
                toggleDrawer={setDrawerToggle}
                machineData={machineData}
                dieselData={dieselData}
              />
            </Drawer>
          )}
        </Grid>
      )}
    </>
  );
};

export default MachineLogs;
